import { Link } from "react-router-dom";
import {
  BsPersonCircle,
  BsChevronDoubleDown,
  BsChevronDoubleUp,
} from "react-icons/bs";
import { GoDot } from "react-icons/go";
import { GiPriceTag, GiPapers } from "react-icons/gi";
import { IoIosResize } from "react-icons/io";
import moment from "moment";
import "moment/locale/es";
import "./ContactRequestCard.scss";

const ContactRequestCard = ({ request }) => {
  const formatValue = (value, ref) => {
    // 1️⃣ Añadimos esta línea: Si no hay valor, devolvemos un guion para que no se rompa
    if (value === null || value === undefined) return "-";

    if (value === 999999999) return "Valor máx.";
    if (value === 0) return "Valor mín.";

    // Como ahora sabemos seguro que "value" es un número, .toString() funcionará siempre
    const formatted = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return ref === "price" ? (
      `${formatted} €`
    ) : (
      <>
        {formatted} m<sup>2</sup>
      </>
    );
  };

  const DataSection = ({ icon: Icon, title, max, min, type }) => (
    <div className="RequestCard__section">
      <h4 className="RequestCard__section-title">
        <Icon className="RequestCard__icon--main" />
        <b>{title}</b>
      </h4>
      <div className="RequestCard__section-content">
        <div className="RequestCard__value">
          <BsChevronDoubleUp className="RequestCard__icon--arrow" />
          <p>{formatValue(max, type)}</p>
        </div>
        <div className="RequestCard__value">
          <BsChevronDoubleDown className="RequestCard__icon--arrow" />
          <p>{formatValue(min, type)}</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="RequestCard">
      <div className="RequestCard__main-container">
        {/* HEADER: Título, Consultor y Tipos */}
        <div className="RequestCard__header">
          <div className="RequestCard__header-top">
            <h4>Petición #{request.requestReference}</h4>
            <div className="RequestCard__consultant">
              <BsPersonCircle className="RequestCard__icon--user" />
              <span>
                {request.requestConsultant?.fullName || "Sin consultor"}
              </span>
            </div>
          </div>

          <span className="RequestCard__date--mobile">
            Creado el {moment(request.createdAt).format("L")}
          </span>

          {request.requestBuildingType?.length > 0 && (
            <div className="RequestCard__zones">
              {request.requestBuildingType.map((type, i) => (
                <p key={i}>
                  <GoDot className="RequestCard__icon--dot" />
                  {type}
                </p>
              ))}
            </div>
          )}
        </div>

        {/* BODY: Los 3 bloques de datos */}
        {/* 2️⃣ Aplicamos Optional Chaining (?.) por si acaso alguna petición no tiene el objeto principal */}
        <div className="RequestCard__body">
          <DataSection
            icon={GiPriceTag}
            title="Precio"
            type="price"
            max={request?.requestSalePrice?.salePriceMax}
            min={request?.requestSalePrice?.salePriceMin}
          />
          <DataSection
            icon={GiPapers}
            title="Superficie construida"
            type="buildSurface"
            max={request?.requestBuildSurface?.buildSurfaceMax}
            min={request?.requestBuildSurface?.buildSurfaceMin}
          />
          <DataSection
            icon={IoIosResize}
            title="Superficie de parcela"
            type="plotSurface"
            max={request?.requestPlotSurface?.plotSurfaceMax}
            min={request?.requestPlotSurface?.plotSurfaceMin}
          />
        </div>
      </div>

      {/* CTA: Botón y Fecha (Desktop) */}
      <div className="RequestCard__footer">
        <span className="RequestCard__date--desktop">
          Creado el {moment(request.createdAt).format("L")}
        </span>
        <Link className="RequestCard__button" to={`/peticiones/${request._id}`}>
          Consultar
        </Link>
      </div>
    </div>
  );
};

export default ContactRequestCard;
